import { getRecoil, setRecoil } from "recoil-nexus";
import participantsState from "../../atoms/participants";
import { socket } from "../index";

interface ListenReceiveLeaveUserPayload {
  roomId: string;
  user: string;
}

const listenReceiveLeaveUser = () => {
  socket?.on('RECEIVE_LEAVE_USER', (payload: ListenReceiveLeaveUserPayload) => {
    const participants = getRecoil(participantsState);

    if (payload.roomId === participants.roomId) {
      setRecoil(participantsState, {
        ...participants,
        users: participants.users.filter((user) => user !== payload.user),
      });
    }
  });
}

export default listenReceiveLeaveUser;